import axios from 'axios'
import { API_URL } from '../../config/api'

export const validate = (value) => {
    return axios.post(`${API_URL}/users/validate`,{
        token: value
    })
        .then(res => {
            return res.data
        })
        .catch(err => {            
            return err.response.message
        })
}

export const emailAtivacao = query => {
    return axios
        .post(`${API_URL}/users/returnpayment`, {
            query: query
        }).then(res => {
            return res.data
        })
        .catch(err => {            
            return err.response.message
        })
}